import { drawRoundedPolygon, fitToSize, sizeOptionsOrDefault } from './utils';
import { MultiPathShape } from './MultiPathShape';
const defaultOptions = {
    shapesOffsetRatio: 0.025,
};
/**
 * Represents a Collate shape, a flowchart element used to indicate collating or gathering operations.
 * Extends MultiPathShape with two triangular shapes arranged in an hourglass pattern.
 */
export class Collate extends MultiPathShape {
    /**
     * Creates a new Collate instance.
     * @param options - Configuration options for the collate shape
     */
    constructor(options) {
        super({ ...defaultOptions, ...options });
    }
    /**
     * @hidden
     * Draws the collate shape path as two triangular shapes forming an hourglass.
     */
    _drawPath() {
        const drawingElement = this.drawingElement;
        const { width, height } = sizeOptionsOrDefault(this.options);
        const cornerRadius = this.options.cornerRadius;
        const strokeWidth = this.options.stroke.width || 0;
        const shapesOffset = height * this.options.shapesOffsetRatio - cornerRadius / 2;
        const halfWidth = width / 2;
        const halfHeight = height / 2;
        const firstShape = [
            { x: halfWidth, y: halfHeight - shapesOffset },
            { x: 0, y: 0 },
            { x: width, y: 0 },
        ];
        drawRoundedPolygon(drawingElement, firstShape, [cornerRadius / 3, cornerRadius, cornerRadius]);
        const secondShape = [
            { x: halfWidth, y: halfHeight + shapesOffset },
            { x: width, y: height },
            { x: 0, y: height }
        ];
        drawRoundedPolygon(drawingElement, secondShape, [cornerRadius / 3, cornerRadius, cornerRadius]);
        fitToSize(drawingElement, width, height, strokeWidth);
    }
}
